module.exports = __webpack_public_path__ + "img/fk.639a7698.svg";